import {
  FETCH_ADDRESSES,
  FETCH_ADDRESSES_SUCCESS,
  FETCH_ADDRESSES_FAILED,
  EDIT_ADDRESS
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, off } from "firebase/database";
import { safePush, safeRead, safeRemove } from '../other/firebaseDbHelper';

const processAddressData = (data, dispatch) => {
  const arr = Object.keys(data).map(i => {
    data[i].id = i;
    return data[i];
  });
  dispatch({ type: FETCH_ADDRESSES_SUCCESS, payload: arr });
};

export const fetchAddresses = () => (dispatch) => {
  const { addressEditRef, auth } = firebase;

  dispatch({ type: FETCH_ADDRESSES, payload: null });

  const userInfo = store.getState().auth.profile;
  if (!userInfo?.uid) return;

  if (auth?.currentUser) {
    off(addressEditRef(userInfo.uid));
    onValue(addressEditRef(userInfo.uid), snapshot => {
      if (snapshot.val()) {
        processAddressData(snapshot.val(), dispatch);
      } else {
        dispatch({ type: FETCH_ADDRESSES_FAILED, payload: store.getState().languagedata.defaultLanguage.no_address });
      }
    });
    return;
  }

  safeRead(`/savedAddresses/${userInfo.uid}`)
    .then((data) => {
      if (data) {
        processAddressData(data, dispatch);
      } else {
        dispatch({ type: FETCH_ADDRESSES_FAILED, payload: store.getState().languagedata.defaultLanguage.no_address });
      }
    })
    .catch(() => {
      dispatch({ type: FETCH_ADDRESSES_FAILED, payload: store.getState().languagedata.defaultLanguage.no_address });
    });
};

export const editAddress = (uid, address, method) => async (dispatch) => {
  const {
    addressRef, 
    addressEditRef,
  } = firebase;
  dispatch({
    type: EDIT_ADDRESS,
    payload: { method, address }
  });
  if (method === 'Add') {
    safePush(addressEditRef(uid), address);
  } else if (method === 'Delete') {
    safeRemove(addressRef(uid, address.id));
  }
}

export const createAddressesOnDb = (uid, address, method) => async (dispatch) => {
  const {
    addressRef, 
    addressEditRef,
  } = firebase;
  dispatch({
    type: EDIT_ADDRESS,
    payload: { method, address }
  });
  if (method === 'Add') {
    safePush(addressEditRef(uid), address);
  } else if (method === 'Delete') {
    safeRemove(addressRef(uid, address.id));
  }
}
